export interface Merged<T> {
    value: T
    hasConflict: boolean
}

/** Fusionne des montants potentiellement divergents : on retient le plus élevé. */
export function mergeAmounts(amounts: Array<number | null>): Merged<number | null> {
    const nonNull = amounts.filter((amount): amount is number => amount !== null)

    return {
        value: nonNull.length > 0 ? Math.max(...nonNull) : null,
        hasConflict: new Set(amounts).size > 1,
    }
}

/** Fusionne des états actif/inactif potentiellement divergents : actif l'emporte. */
export function mergeActive(actives: boolean[]): Merged<boolean> {
    return {
        value: actives.some(Boolean),
        hasConflict: new Set(actives).size > 1,
    }
}
